<template>
    <base-side-bar
        ><div
            class="flex flex-col items-center justify-center flex-grow w-full mx-10"
        >
            <h2
                class="font-extrabold leading-9 text-center text-blue-600 text-xxxl sm:text-xl sm:leading-10"
            >
                Achats prévisionnels
            </h2>
            <br />
            <div class="flex flex-col items-center justify-center w-full">
                <wide-card>
                    <tag-group :tags="tags" @clicked="checkPurchaseType" />
                </wide-card>

                <template v-if="achatsPrevisionnel.type === 'details'">
                    <component
                        ref="achats"
                        v-for="(achatCard, index) in achatCardsArray"
                        :key="achatCard.key"
                        :is="achatCard.model"
                        :object="achatCard.object"
                        v-on:remove="removeAchatCard($event, index)"
                    />
                    <base-add-button
                        title="Ajouter un achat "
                        @click="addAchatCard"
                    />

                    <wide-card
                        title="Taux d'évolution des achats"
                        titleClass="text-center mb-2"
                    >
                        <base-number-input
                            :max="100"
                            label="Taux d’évolution des achats (%)"
                            v-model="tauxEvolutionAchats"
                            :hasError="$v.tauxEvolutionAchats.$error"
                            :errorMessage="
                                errorMessage(
                                    'Taux d’évolution des achats',
                                    $v.tauxEvolutionAchats
                                )
                            "
                            @blur="$v.tauxEvolutionAchats.$touch()"
                        />
                    </wide-card>
                    <wide-card
                        title="Total achats Prévisionnels (HT)"
                        titleClass="text-center mb-2"
                    >
                        <h2
                            class="mr-6 text-sm font-extrabold leading-9 text-left text-blue-600 sm:text-lg sm:leading-10"
                        >
                            Total
                        </h2>
                        <div class="flex items-center w-full bg-gray-300">
                            <h2 class="p-2 text-lg font-extrabold leading-9">
                                {{ totalAP }}
                            </h2>
                        </div>
                    </wide-card>
                    <wide-card
                        title="CA à l’import"
                        titleClass="text-center mb-2"
                    >
                        <h2
                            class="mr-6 text-sm font-extrabold leading-9 text-left text-blue-600 sm:text-lg sm:leading-10"
                        >
                            Total
                        </h2>
                        <div class="flex items-center w-full bg-gray-300">
                            <h2 class="p-2 text-lg font-extrabold leading-9">
                                {{ caInmport }}
                            </h2>
                        </div>
                    </wide-card>
                </template>

                <wide-card v-if="achatsPrevisionnel.type === 'total'">
                    <base-number-input
                        label="Total achats prévisionnels en % du CA"
                        v-model="achatsPrevisionnel.totalPrice"
                        :hasError="$v.achatsPrevisionnel.totalPrice.$error"
                        :errorMessage="
                            errorMessage(
                                'Total achats prévisionnels en % du CA',
                                $v.achatsPrevisionnel.totalPrice
                            )
                        "
                        :max="100"
                        @blur="$v.achatsPrevisionnel.totalPrice.$touch()"
                    />

                    <base-number-input
                        :max="100"
                        label="Taux d’évolution des achats (%)"
                        v-model="achatsPrevisionnel.tauxEvolution"
                        :hasError="$v.achatsPrevisionnel.tauxEvolution.$error"
                        :errorMessage="
                            errorMessage(
                                'Taux d\'évolution',
                                $v.achatsPrevisionnel.tauxEvolution
                            )
                        "
                        @blur="$v.achatsPrevisionnel.tauxEvolution.$touch()"
                    />

                    <div class="flex items-center mt-8">
                        <h5 class="mr-4">Import</h5>
                        <toggle
                            class="mr-6"
                            :triggered="achatsPrevisionnel.isImporter"
                            v-on:toggleTriggered="
                                e => (achatsPrevisionnel.isImporter = e)
                            "
                        />
                    </div>
                    <base-number-input
                        :max="100"
                        v-if="achatsPrevisionnel.isImporter"
                        label="Pourcentage achat à l’import"
                        v-model="achatsPrevisionnel.pourcentageAchatImport"
                    />
                </wide-card>
                <base-primary-button title="Suivant" @click="addAchatPR" />
            </div></div
    ></base-side-bar>
</template>

<script>
import AchatCard from "./Achats_previsionnels/AchatCard";
import WideCard from "@/components/cards/wideCard";
import TagGroup from "@/components/forms/TagGroup";
import Toggle from "@/components/forms/Toggles/simpleToggle";
import {
    required,
    decimal,
    minValue,
    maxValue
} from "vuelidate/lib/validators";
import { mapState } from "vuex";
import { errorMessage } from "@/mixins/errorMessage.js";
import { scrollToError } from "@/mixins/scrollToMixin.js";

export default {
    components: {
        AchatCard,
        WideCard,
        TagGroup,
        Toggle
    },

    mixins: [errorMessage, scrollToError],

    validations() {
        if (this.achatsPrevisionnel.type === "total") {
            if (!this.achatsPrevisionnel.isImporter)
                return {
                    achatsPrevisionnel: {
                        totalPrice: {
                            required,
                            decimal,
                            minValue: minValue(0),
                            maxValue: maxValue(100)
                        },
                        pourcentageAchatImport: {
                            decimal,
                            minValue: minValue(0),
                            maxValue: maxValue(100)
                        },
                        tauxEvolution: {
                            decimal,
                            minValue: minValue(0),
                            maxValue: maxValue(100)
                        }
                    }
                };
            return {
                achatsPrevisionnel: {
                    totalPrice: {
                        required,
                        decimal,
                        minValue: minValue(0)
                    },
                    tauxEvolution: {
                        decimal,
                        minValue: minValue(0),
                        maxValue: maxValue(100)
                    }
                }
            };
        }
        return {
            tauxEvolutionAchats: {
                required,
                decimal,
                minValue: minValue(0),
                maxValue: maxValue(100)
            }
        };
    },
    created() {
        this.$store.dispatch("forms/showSection", "Étude Financiere");
        this.$store.dispatch("forms/stepFocus", "Achats Prévisionnels");
    },
    mounted() {
        this.achatsPrevisionnel = this.$store.getters[
            "EtudeFinanciere/getAcharPrev"
        ];
        this.tauxEvolutionAchats = this.$store.getters[
            "EtudeFinanciere/getAcharPrev"
        ].tauxEvolution;
        this.achatCardsArray = this.$store.getters[
            "EtudeFinanciere/getAcharPrev"
        ].achatObject;

        this.tags.forEach(elem => {
            if (elem.value === this.achatsPrevisionnel.type)
                elem.isActive = true;
        });
    },
    data() {
        return {
            achatsPrevisionnel: {},
            achatCardsArray: [],
            tags: [
                {
                    name: "Achats Prévisionnels - Total",
                    value: "total",
                    isActive: false
                },
                {
                    name: "Achats Prévisionnels - Détails",
                    value: "details",
                    isActive: false
                }
            ],
            tauxEvolutionAchats: null
        };
    },
    methods: {
        checkPurchaseType(e) {
            this.achatsPrevisionnel.type = e;
        },
        addAchatCard() {
            if (!this.checkForms()) {
                this.achatCardsArray.push({
                    model: "achat-card",
                    key: new Date().getTime(),
                    object: {
                        id: new Date().getTime(),
                        isImporter: false,
                        name: "",
                        prixAchat: null,
                        quantite: 0,
                        date: null,
                        unite: "",
                        pourcentagePartImportee: 0,
                        choixArticle: ""
                    }
                });

                this.$refs.achats[this.$refs.achats.length - 1].scrollToRef();
            } else {
                this.scrollToError();

                this.$emit("showNotification", {
                    error: true,
                    content:
                        "Une erreur a été détectée, veuillez revérifier les informations remplies.",
                    title: "Attention"
                });
            }
        },
        addAchatPR() {
            this.$v.$touch();
            if (!this.$v.$invalid) {
                if (this.achatsPrevisionnel.type === "details") {
                    this.$store.dispatch(
                        "EtudeFinanciere/addTauxDachat",
                        this.tauxEvolutionAchats
                    );
                    if (
                        !this.checkForms() &&
                        this.achatsPrevisionnelLength >= 1
                    ) {
                        this.$store.dispatch(
                            "EtudeFinanciere/SaveAchatsPrevisionnel"
                        );
                        this.$router.push({ name: "autres_charges_externes" });
                    } else {
                        this.scrollToError();

                        this.$emit("showNotification", {
                            error: true,
                            content:
                                "Une erreur a été détectée, veuillez revérifier les informations remplies.",
                            title: "Attention"
                        });
                    }

                    this.$store.dispatch(
                        "forms/subStepComplete",
                        "Achats Prévisionnels"
                    );
                } else {
                    this.$store.dispatch(
                        "EtudeFinanciere/addAchatsPrevisionnelTotal",
                        this.achatsPrevisionnel
                    );
                    this.$store.dispatch(
                        "EtudeFinanciere/SaveAchatsPrevisionnel"
                    ),
                        this.$store.dispatch(
                            "forms/subStepComplete",
                            "Achats Prévisionnels"
                        );
                    this.$router.push({ name: "autres_charges_externes" });
                }
            } else {
                this.$emit("showNotification", {
                    error: true,
                    content:
                        "Une erreur a été détectée, veuillez revérifier les informations remplies.",
                    title: "Attention"
                });
            }
        },
        checkForms() {
            let formsHasError = false;
            this.$refs.achats.forEach(item => {
                if (!item.addAchatsPrevisionnel()) {
                    formsHasError = true;
                }
            });
            return formsHasError;
        },
        removeAchatCard(payload, index) {
            this.$store.dispatch("EtudeFinanciere/removeAchat", payload);
            this.achatCardsArray.splice(index, 1);
        }
    },
    computed: {
        ...mapState("EtudeFinanciere", {
            achatsPrevisionnelLength: state =>
                state.achatsPrevisionnel.achats.length,
            totalAP: state => {
                if (state.achatsPrevisionnel.type !== "details") return 0;
                return state.achatsPrevisionnel.achats.reduce(
                    (a, b) => a + parseInt(b.prixAchat) * parseInt(b.quantite),
                    0
                );
            },
            caInmport: state => {
                if (state.achatsPrevisionnel.type !== "details") return 0;

                return state.achatsPrevisionnel.achats.reduce((a, b) => {
                    if (b.isImporter)
                        return (
                            a +
                            (parseInt(b.prixAchat) *
                                parseInt(b.quantite) *
                                parseInt(b.pourcentagePartImportee)) /
                                100
                        );
                    return a;
                }, 0);
            }
        })
    }
};
</script>

<style></style>
